import { h } from './dom';

export interface DropzoneOptions {
  label: string;
  hint: string;
  accept: string;
  onFiles: (files: File[]) => void;
  filter?: (file: File) => boolean;
}

export function dropzone(o: DropzoneOptions): HTMLElement {
  const input = h('input', { type: 'file', accept: o.accept, class: 'dropzone-input' });
  const zone = h('div', { class: 'dropzone', tabIndex: 0, attrs: { role: 'button', 'aria-label': o.label } }, h('strong', null, o.label), h('span', { class: 'dropzone-hint' }, o.hint), input);
  const deliver = (files: File[]) => {
    const list = o.filter ? files.filter(o.filter) : files;
    if (list.length > 0) o.onFiles(list);
  };
  zone.addEventListener('click', () => input.click());
  zone.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      input.click();
    }
  });
  input.addEventListener('change', () => {
    deliver(Array.from(input.files ?? []));
    input.value = '';
  });
  zone.addEventListener('dragover', (e) => {
    e.preventDefault();
    zone.classList.add('is-over');
  });
  zone.addEventListener('dragleave', () => zone.classList.remove('is-over'));
  zone.addEventListener('drop', (e) => {
    e.preventDefault();
    zone.classList.remove('is-over');
    deliver(Array.from(e.dataTransfer?.files ?? []));
  });
  return zone;
}
